import { BLAdmin } from '@/types/profile.types';
import { Get } from '../helpers';
import { EmailDomainFlag } from '@/types/email-domain-flags.types';

export function GetAdmins(
  channel: number,
  includeLockedEmails = false
): Promise<
  (BLAdmin & { flags: EmailDomainFlag[] })[] | { admins: BLAdmin[]; temporarilyLockedEmails: { [key: string]: string } }
> {
  return Get({
    url: `/v3/admin/auth/admins?onlyChannel=${channel}${includeLockedEmails ? '&option=includeLockedEmails' : ''}`,
  });
}
